<template>
  <!-- <title-image></title-image> -->
  <RouterView />
<!--  <a href="https://www.flaticon.com/free-icons/wedding" title="wedding icons" class="icon-attribution">Wedding icons created by Freepik - Flaticon</a>-->
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: "Dancing Script", serif;
  font-optical-sizing: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #36454F;
  background-color: #FFFFFF;
  height: 100vh;
}

#app {
  font-family: "Playfair", serif;
  font-optical-sizing: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #36454F;
  background-color: #FFFFFF;
  height: 100vh;
}
</style>
